import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledUneditableText = styled(Ds.Text).attrs({
    size: "small",
})`
    color: var(--ds-color-stone);
`;
